import { render, staticRenderFns } from "./Proximo.vue?vue&type=template&id=45360c14&"
import script from "./Proximo.vue?vue&type=script&lang=ts&"
export * from "./Proximo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports